
import { View} from 'backbone';
import _template from 'properties/main/autocomplete.ejs';
import restService from 'RestService';
import util from 'util/Util.js'
import notificationService from 'NotificationService.js';
import behaviorHelperService from 'BehaviorHelperService.js';
import factoryService from 'FactoryService.js';
import listService from 'ListService.js';
import MainSendView from 'behaviors/properties/main/MainSendView.js';
import constants from 'Constants.js';
import textUtil from 'util/TextUtil.js';

class MainAutoComplete extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change select' : 'updateAttributes',
            'change input[type=checkbox]' : 'updateCheckAttributes',
            'change input[type=numeric]' : 'updateInputAttribute',
            'click  .refresh-dropdown' : 'refresh'
        };

        this.autocompleteBehavior = null;
        this.behaviorInstance = null;
        this.firstLoad = true;
        this.refreshing = false;
     
        this.currentModel = this.model.get("factoryKey") !== "control_table" ? this.model : this.model.get('gridData')[this.colId];

        this.listenTo(this.currentModel, 'change', this.render);

        if(!this.currentModel.get("autocompleteEnabled")){
            this.currentModel.set("autocompleteEnabled", false, {silent:true});
        }

        if(!this.currentModel.get("autocompleteSource")){
            this.currentModel.set("autocompleteSource", "none", {silent:true});
        }else{
            this.getBehavior();
        }

        if(!this.currentModel.get("autocompleteActivateOn")){
            this.currentModel.set("autocompleteActivateOn", '5', {silent:true});
        }

        return this;
    }

    getBehavior(){
        if (util.isTrue(this.currentModel.get("autocompleteEnabled")) && this.currentModel.get("autocompleteSource") !== "none") {
            this.behaviorInstance = listService.getBehaviorInstanceByObjectAndBehaviorKey(this.currentModel.get("id"), "onAutoComplete");
            if (this.behaviorInstance) {
                this.autocompleteBehavior = listService.getBehaviorInstanceObjects(this.behaviorInstance.id).entries().next();
                this.autocompleteBehavior = this.autocompleteBehavior && this.autocompleteBehavior.value ? this.autocompleteBehavior.value[1] : null;
                listService._currentBehaviorInstanceId = this.behaviorInstance.id;

                //Always apply changes to instance
                if (this.behaviorInstance && typeof this.behaviorInstance.get('parsedItem') !== 'undefined') {
                    this.behaviorInstance.unset('parsedItem');
                }
            }
        }
    }

    updateInputAttribute(ev){
        ev.preventDefault();
        let propVal  = ev.currentTarget.value;
        const propName = ev.currentTarget.name;  


        if(propName === "autocompleteActivateOn"){

            if (!textUtil.isNumeric(propVal)) {
                let lastValue = this.currentModel.get(propName);
                propVal = lastValue;
            }

            if(propVal < 3){
                propVal = 3;
            }
        }

        $('#autocompleteActivateOn').val(propVal);

        this.currentModel.set( propName, propVal, {silent: true} );
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propVal  = ev.currentTarget.checked;
        const propName = ev.currentTarget.name;        

        this.currentModel.set( propName, propVal );

        if (propVal) {
            this.getBehavior();

            if (!this.behaviorInstance) {
                this.behaviorInstance = { behaviorKey: 'onAutoComplete', objectId: this.currentModel.get("id") }
                behaviorHelperService.createNewInstanceOnLoad(this.behaviorInstance);
            }

            if (this.currentModel.get("autocompleteSource") === "connection") {
                this.loadTypeConnection();
            }else if (this.currentModel.get("autocompleteSource") === "list") {
                this.getLists();
            }
        }
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const optionSelected=$(`select[name='${propName}'] option[value='${propVal}']`);
        let factoryKey = propVal === "connection" ? "command_connect" : "command_comment";

        switch(propName){
            case 'autocompleteSource':

                //If a command already exists delete it
                if(this.autocompleteBehavior){
                    listService.deleteBehaviorObject(this.autocompleteBehavior.model.get("id"));
                }

                if(propVal !== "none"){
                    //Create new command
                    const factoryParams = factoryService.behaviorsFactories[factoryKey];
                    this.autocompleteBehavior = factoryParams.factory.createView(factoryKey, {left:0, top:0});                
                    listService.addBehaviorObject(this.autocompleteBehavior.id, this.autocompleteBehavior);
                }   

                if(this.currentModel.get("factoryKey") !== "control_table"){        
                    this.currentModel.set( propName, propVal);
                }
                else{
                    this.currentModel.get('gridData')[this.colId].attributes[propName] = propVal;
                    this.render();
                }
                
                switch(propVal){
                    case 'connection':
                        if(this.currentModel.get("listId") && this.currentModel.get("listId") !== ""){
                            this.currentModel.set("listId", '', {silent:true});
                        }                        
                        this.loadTypeConnection();
                    break;
                    case 'list':
                        this.resetConnection();
                        this.getLists();
                    break;
                }  
                
                           
            break;
            case 'connection':   

                if(propVal !== "none"){
                    this.autocompleteBehavior.model.set('connectionName', $(optionSelected).text(), {silent:true});
                    this.autocompleteBehavior.model.set('connectionId', propVal, {silent:true});
                    this.getActions(propVal);
                }else{
                    this.resetConnection();
                    this.loadTypeConnection();
                }                
                
            break;
            case 'action':
                if(propVal !== "none"){
                    this.autocompleteBehavior.model.set('actionName', $(optionSelected).text(), {silent:true});
                    this.autocompleteBehavior.model.set('actionId', propVal, {silent:true});                
                    this.getConnectionParameters();
                }else{
                    this.resetConnection();
                    this.getActions();
                }
            break;
            case 'source':
                const self = this;
                const existingParams = this.autocompleteBehavior.model.get("Request").Receive.parameter;
                  
                _.forEach(existingParams, (param, i) =>{

                    if(param._id === propVal){
                        param._value = self.model.get("id");                    
                    }else{
                        param._value = "";
                    }
                });
            break;
            case 'listId':
                if(this.currentModel.get("listId") && this.currentModel.get("listId") !== ""){
                    this.currentModel.set("listId", '', {silent:true});
                }

                this.currentModel.set( propName, propVal, {silent:true});
            break;
            default:
                this.currentModel.set( propName, propVal);
            break;
        }
    }

    resetConnection(){

        if(this.autocompleteBehavior && this.autocompleteBehavior.model){
            this.autocompleteBehavior.model.set('connectionName', '', {silent:true});
            this.autocompleteBehavior.model.set('connectionId', '', {silent:true});
            this.autocompleteBehavior.model.set('actionName', '', {silent:true});
            this.autocompleteBehavior.model.set('actionId', '', {silent:true});     
            this.autocompleteBehavior.model.set('gridData', [], {silent: true});
            this.autocompleteBehavior.model.set('gridData2', [], {silent: true});     
        }    
    }

    deleteGridRows() {
        this.autocompleteBehavior.model.set('gridData', [], {silent: true});
        this.autocompleteBehavior.model.set('gridData2', [], {silent: true});

        util.deleteGridRows(constants.PROP_MAIN_TABLE);
        util.deleteGridRows(constants.PROP_MAIN_TABLE2);
    }

    getConnectionParameters(){

        const sourceSelect = $('select[name="source"]');
        const connectionId = $('select[name="connection"]').val();
        const actionId = $('select[name="action"]').val();
        const behaviorModel = this.autocompleteBehavior.model;

        const prevRequest = behaviorModel.get('Request');

        this.deleteGridRows();
        let RequestSendParams = [];
        let RequestReceiveParams = [];
        let gridData = [];
        const self = this;

        const getObjectName = (value) => {

            let objName = '';
            const id = value;
            const obj = listService.getObject(listService.cleanId(id));

            if (obj && (!constants.CONTROL_CAPTION_VALUE_KEYS.contains(obj.model.get('factoryKey'))
                || (receiveParameter._type === 'itemsValue' || receiveParameter._type === 'itemsCaption'))) {
                objName = obj ? obj.model.get('name') : '';
            } else {
                objName = listService.determineFieldName(id);
                objName = objName ? objName : '';
            }

            return objName;
        }

        const setReturnParams = (parameters) => {
            
            const existingReturnParams = prevRequest.Receive.parameter;
            const existingParam = existingReturnParams.find(param => param._value === self.model.get("id"));
                   
            util.appendOptionToSelect(sourceSelect, 'none', 'Select Source', !existingParam);
            let select = false;
            for (let returnParameter of parameters.returnParameters) {
                if (typeof returnParameter !== 'undefined') {
                    select = existingParam && returnParameter._id === existingParam._id;
                    util.appendOptionToSelect(sourceSelect, returnParameter._id, returnParameter._name, select);

                    let newParam = select ? existingParam : {
                        _id: returnParameter._id,
                        _name: returnParameter._name,
                        _value: '', 
                        _show: 'false',
                        _emptyDefaultItem: 'false'
                    };

                    RequestReceiveParams.push(newParam);                    
                }
            }
            behaviorModel.attributes.Request.Receive.parameter = RequestReceiveParams;            
        }

        const setSendParams = (parameters) => {
            const existingSendParams = prevRequest.Send.parameter;

            for (let sendParameter of parameters.sendParameters) {
                if (typeof sendParameter !== 'undefined') {
                    gridData = behaviorModel.get('gridData');

                    const existingParam = existingSendParams.find(param => param._name === sendParameter._name);

                    let newRow = {
                        'name': sendParameter._name,
                        'source': '',
                        'formula': '',
                        'isDefault': ''
                    };

                    if (existingParam) {
                        const objName = getObjectName(existingParam._value);
                        let object = existingParam._type === 'expression' ? '[Formula]' : objName;
                        newRow = {
                            'name': sendParameter._name,
                            'source': object,
                            'formula': existingParam._type === 'expression' ? 'selected' : '',
                            'isDefault': ''
                        };
                    }

                    $(constants.PROP_MAIN_TABLE).addRowData((gridData.length), newRow);

                    gridData.push(newRow);
                    const prevSendRequest = prevRequest.Send.parameter.find(param => param._id === sendParameter._id);
                    let newParam = prevSendRequest !== undefined
                        ? prevSendRequest : {
                            _id: sendParameter._id,
                            _name: sendParameter._name,
                            _type: 'field', _value: '',
                            _show: 'false',
                            _emptyDefaultItem: 'false'
                        };

                    RequestSendParams.push(newParam);
                }
            }
            $('.format-table-properties').css("height", "100%");
            behaviorModel.set('gridData', gridData, { silent: true });
            behaviorModel.attributes.Request.Send.parameter = RequestSendParams;
        }

        if (connectionId !== "none" && actionId !== "none") {

            if (connectionId !== "meta") {
                restService.getParametersByActionIdAndConnectionId(actionId, connectionId).then((parameters) => {

                    //Get return parameters to source
                    if (typeof parameters.returnParameters !== 'undefined') {
                        setReturnParams(parameters);
                    }

                    if (typeof parameters.sendParameters !== 'undefined') { //Get send parameters to table
                        setSendParams(parameters);                        
                    }

                }).catch((error) => {
                    notificationService.error("An error has ocurred retrieving the connection parameters.")
                    console.log('The following error has ocurred', error)
                });
            }else{
                let parameters;
                switch (actionId) {
                    case 'users':
                        parameters = constants.META_USERS_PARAMETERS
                        break;
                    case 'positions':
                        parameters = constants.META_POSITIONS_PARAMETERS
                        break;
                    case 'usergroups':
                        parameters = constants.META_USER_GROUPS_PARAMETERS
                        break;
                }

                setReturnParams(parameters);
                setSendParams(parameters);
            }
        }
    }

    refresh(ev){
        ev.preventDefault();
        const source = $(ev.currentTarget).data().source;

        if (!this.refreshing) {
            this.refreshing = true;

            switch (source) {
                case 'connection':
                    this.getConnections();
                    break;
                case 'action':
                    this.getActions();
                    break;
                case 'list':
                    this.getLists();
                    break;
            }
        }
    }

    getLists(){
        const listSelect = $('select[name="listId"]');
        listSelect.empty();
        const existingList = this.currentModel.get("listId") || '' ;

        restService.browseCustomList().then(customLists => {
            let select = false;
            const lists = !Array.isArray(customLists) ? [customLists] : customLists;

            if ($.isEmptyObject(lists)){
                util.appendOptionToSelect(listSelect, 'none', 'No Lists Available', true);
            }else{
                util.appendOptionToSelect(listSelect, 'none', 'Select List', existingList === '');
                
                _.forEach(lists, (list, i) => {
                    select = list['@CustomListGUID'] === existingList;
                    util.appendOptionToSelect(listSelect, list['@CustomListGUID'], list['@Name'], select );
                });

            }

            this.refreshing = false;
        });
    }

    getConnections(){
        //Clean dropdowns
        $('.dd-connection').empty();
        const connectionSelect = $('select[name="connection"]');
        const existingConnection = this.autocompleteBehavior ? this.autocompleteBehavior.model.get("connectionId") : '';
        let select = false;
        const self = this;
       
        restService.getConnectionsAutocomplete().then((connections)=> {

            util.appendOptionToSelect(connectionSelect, 'none', 'Select Connection', existingConnection === '');
            if ($.isEmptyObject(connections)){
                util.appendOptionToSelect(connectionSelect, "meta", "System Meta Data", existingConnection === "meta");
            }else{                
                _.forEach(connections, (connection, i) => {
                    select = connection['@ConnectionId'] === existingConnection;
                    util.appendOptionToSelect(connectionSelect, connection['@ConnectionId'], connection['@Name'], select, connection['@Type'] );
                });              
                util.appendOptionToSelect(connectionSelect, "meta", "System Meta Data", existingConnection === "meta");

                if(existingConnection !== ''){
                    self.getActions();
                }
            }
            
         }, function(err) {
            console.log(err);
            notificationService.error( 'An error has ocurred retrieving connections.' );
         });
    }

    loadTypeConnection() {
        const sendParams = new MainSendView({ model: this.autocompleteBehavior.model, el: $('#propMainSend'), settings:{addMinRows: false} });
        sendParams.render();
        this.getConnections();
    }

    getActions() {
        const connectionId = $('select[name="connection"]').val();
        const existingAction = this.autocompleteBehavior ? this.autocompleteBehavior.model.get("actionId") : '';
        let select = false;
        const self = this;

        const setActions = (actions) =>{
            const actionSelect = $('select[name="action"]');
            const sourceSource = $('select[name="source"]');
            actionSelect.empty();
            sourceSource.empty();

            if ($.isEmptyObject(actions)) {
                util.appendOptionToSelect(actionSelect, 'none', 'No Actions Available', true);
            }
            else {
                util.appendOptionToSelect(actionSelect, 'none', 'Select Action', existingAction === '');
                _.forEach(actions, (action, i) => {
                    select = action['@ActionId'] === existingAction;
                    util.appendOptionToSelect(actionSelect, action['@ActionId'], action['@Name'], select);
                });

                if (existingAction !== '') {
                    self.getConnectionParameters();
                }
            }
        }


        if (connectionId !== "meta") {
            restService.getActionsAutocomplete(connectionId).then(actions => {

                setActions(actions);                
                this.refreshing = false;

            }).then(() => {

            }, function (err) {
                console.log(err);
                notificationService.error('An error has ocurred retrieving actions.');
            });
        } else {
            setActions(constants.META_DATA_ACTIONS);
        }
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.currentModel.toJSON()));
        }

        if(this.firstLoad){
            if(this.currentModel.get("autocompleteSource") === "connection" && this.autocompleteBehavior && this.autocompleteBehavior.model.get("connectionId")){
                this.loadTypeConnection();              
            }
            
            if(this.currentModel.get("autocompleteSource") === "list"){
                this.getLists();
            }

            this.firstLoad = false;
        }

        this.delegateEvents();
        return this;
    }

}

export default MainAutoComplete;